/* ==========================================================================
   PROMO BANNER CLOSE — the top announcement marquee gets a dismiss "X".
   ==========================================================================
   The scrolling promo bar (#LV2_MARQUEE_TOP on desktop, #LV2_MARQUEE in
   portrait — built by product_browser.js from the footer_repeating_announcement
   metafield) gains a bar-height square close button on its right edge.

   Pressing it:
     1. The X becomes un-interactable and spins, accelerating from a standstill.
     2. After a short beat the bar SHATTERS into a fine grid of fragments that
        burst outward and fall away, while its height animates to 0 — so the
        flex sibling (#BROWSER) expands smoothly into the reclaimed space.

   DISMISSAL IS FOR THE CURRENT VISIT ONLY, held in memory. DECOY navigates
   client-side (opening products never reloads the document), so a
   dismissed bar stays gone for the whole visit — but a real page reload, a new
   tab, or clearing site data brings it straight back. (An earlier version used
   sessionStorage, which survived reloads and session-restore and left no easy
   way to get the bar back; this does not.)

   prefers-reduced-motion skips the cutscene and closes immediately.

   Self-contained: it only reads stable ids/classes and owns everything it
   injects. Nothing in product_browser.js needs to change.
   ========================================================================== */
;(function () {
    'use strict';

    var SPIN_MS = 1700;      /* the X winds up for this long before the blast */
    var SAND_GAP = 6;        /* particle spacing in px — smaller = finer sand */
    var SAND_MS = 1400;      /* burst lifetime */

    var dismissed = false;   /* in-memory; resets on any real page load */

    var reduce = false;
    try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { reduce = false; }

    function bars() {
        return ['LV2_MARQUEE_TOP', 'LV2_MARQUEE']
            .map(function (id) { return document.getElementById(id); })
            .filter(Boolean);
    }
    function hasContent(bar) {
        return !!(bar && bar.querySelector('.lv2-marquee-track'));
    }

    var busy = false;
    var crackCtl = null;

    /* ---- crack under the load (glass) --------------------------------------
       The bar fractures like glass failing under the page's weight. Structure
       follows real glass, not random scratches: a few IMPACT ORIGINS (one at
       the close button, causally tied to the click, plus two edge impacts) each
       throw a clipped fan of RADIAL cracks that run to the nearest edge and then
       continue ALONG it (edge-runners — the wide-short 31:1 aspect's version of
       a bullseye), tied together by CONCENTRIC arc connectors. Radials fire
       before their concentrics; origins fire in sequence; a centre burst lands
       the full-pane fracture right before the blast. Each path draws-on from its
       origin (birthT/grow) so it propagates. Params: designer agent, tuned to
       the 1280x41 box; glow + tapered core sell the glassy edge. */
    function jaggedLine(x0, y0, angle, len, segs, jit) {
        var pts = [[x0, y0]], x = x0, y = y0, a = angle, step = len / segs;
        for (var i = 0; i < segs; i++) {
            a += (Math.random() * 2 - 1) * jit;
            x += Math.cos(a) * step; y += Math.sin(a) * step;
            pts.push([x, y]);
        }
        return pts;
    }
    /* The bar is being CRUSHED top-to-bottom, so it cracks like glass under
       compression: many short VERTICAL fractures biting inward from the top and
       bottom edges, multiplying and lengthening across the whole width until it
       gives. Cracks snap in instantly (each drawn once, additively — see
       crackle) and escalate by birthT: tiny edge nicks -> more/longer -> a dense
       top+bottom field -> near-through splits + edge craze -> shatter. */
    function buildGlass(W, H, light) {
        var cracks = [], i, f = light ? 0.5 : 1;   /* cold click -> lighter fracture */
        function add(pts, w, birthT) { cracks.push({ pts: pts, w: w, birthT: birthT }); }
        /* one mostly-vertical crack biting in from the top or bottom edge */
        function vcrack(x, fromTop, lenFrac, w, birthT) {
            var y0 = fromTop ? 0 : H;
            var ang = (fromTop ? 1 : -1) * Math.PI / 2 + (Math.random() * 2 - 1) * 0.3;
            var len = H * lenFrac;
            add(jaggedLine(x, y0, ang, len, Math.max(2, Math.round(len / 6)), 0.3), w, birthT);
        }
        /* a row of cracks spread evenly across the width (jittered) */
        function row(count, edgeFn, lenLo, lenHi, wLo, wHi, btLo, btHi) {
            for (var k = 0; k < count; k++) {
                var x = W * (k + 0.5) / count + (Math.random() * 2 - 1) * (W / count) * 0.35;
                vcrack(x, edgeFn(k), lenLo + (lenHi - lenLo) * Math.random(),
                    wLo + (wHi - wLo) * Math.random(), btLo + (btHi - btLo) * Math.random());
            }
        }
        var rnd = function () { return Math.random() < 0.5; };
        var top = function () { return true; }, bot = function () { return false; };
        /* A — tiny nicks along both edges */
        row(Math.round(7 * f), rnd, 0.08, 0.16, 0.6, 0.9, 0.0, 0.14);
        /* B — more, a little longer */
        row(Math.round(11 * f), function (k) { return k % 2 === 0; }, 0.16, 0.3, 0.8, 1.2, 0.16, 0.4);
        /* C — dense field, top AND bottom, biting well inward (the crush) */
        row(Math.round(16 * f), top, 0.32, 0.55, 1.0, 1.5, 0.42, 0.66);
        row(Math.round(16 * f), bot, 0.32, 0.55, 1.0, 1.5, 0.44, 0.68);
        /* D — it gives: near-through vertical splits + short craze at the edges */
        row(Math.round(12 * f), rnd, 0.62, 0.95, 1.1, 1.6, 0.72, 0.9);
        var craze = Math.round(20 * f);
        for (i = 0; i < craze; i++) {
            var ct = rnd();
            add(jaggedLine(W * Math.random(), ct ? H * (0.03 + 0.18 * Math.random()) : H * (0.79 + 0.18 * Math.random()),
                (Math.random() * 2 - 1) * Math.PI, 5 + Math.random() * 12, 2, 0.5),
                0.6 + 0.3 * Math.random(), 0.8 + 0.18 * Math.random());
        }
        return cracks;
    }
    function strokePath(ctx, pts, drawn) {
        ctx.beginPath();
        ctx.moveTo(pts[0][0], pts[0][1]);
        var full = Math.floor(drawn), i;
        for (i = 1; i <= full && i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
        var frac = drawn - full;
        if (full + 1 < pts.length && frac > 0) {
            var a = pts[full], b = pts[full + 1];
            ctx.lineTo(a[0] + (b[0] - a[0]) * frac, a[1] + (b[1] - a[1]) * frac);
        }
        ctx.stroke();
    }
    function drawGlassCrack(ctx, cr, ink, haloA) {
        var pts = cr.pts, n = pts.length - 1;
        if (n < 1) return;
        ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        /* soft halo (cheap wide low-alpha pass, no shadowBlur) */
        ctx.strokeStyle = 'rgba(' + ink + ',' + haloA + ')';
        ctx.lineWidth = cr.w * 2.6 + 1;
        strokePath(ctx, pts, n);
        /* tapered bright core: thick at the edge root, thin at the inner tip */
        ctx.strokeStyle = 'rgba(' + ink + ',0.92)';
        for (var i = 0; i < n; i++) {
            ctx.lineWidth = Math.max(0.4, cr.w * (1 - 0.6 * i / n));
            ctx.beginPath();
            ctx.moveTo(pts[i][0], pts[i][1]);
            ctx.lineTo(pts[i + 1][0], pts[i + 1][1]);
            ctx.stroke();
        }
    }
    /* Additive: each crack is painted ONCE the moment it snaps in and the canvas
       is never cleared, so per-frame cost is ~nil (the old full redraw of every
       crack every frame was the lag). */
    function crackle(rect, light) {
        if (!rect || rect.width < 2 || rect.height < 2) return { stop: function () {} };
        var lightMode = document.documentElement.classList.contains('lightMode');
        var ink = lightMode ? '0,0,0' : '238,238,238';
        var haloA = lightMode ? 0.14 : 0.1;
        var W = rect.width, H = rect.height;
        var dpr = Math.max(1, Math.min(1.5, window.devicePixelRatio || 1));
        var canvas = document.createElement('canvas');
        canvas.className = 'lv2-promo-cracks';
        canvas.style.cssText = 'position:fixed;left:' + rect.left + 'px;top:' + rect.top +
            'px;width:' + W + 'px;height:' + H + 'px;z-index:100039;pointer-events:none;';
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        var ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
        document.body.appendChild(canvas);
        var cracks = buildGlass(W, H, light);
        var startT = null, stopped = false, raf = null;
        function frame(now) {
            if (stopped) return;
            if (startT == null) startT = now;
            var t = Math.min(1, (now - startT) / SPIN_MS);
            for (var i = 0; i < cracks.length; i++) {
                var cr = cracks[i];
                if (!cr.done && t >= cr.birthT) { drawGlassCrack(ctx, cr, ink, haloA); cr.done = true; }
            }
            if (t < 1) raf = requestAnimationFrame(frame);
        }
        raf = requestAnimationFrame(frame);
        return {
            stop: function () {
                stopped = true;
                if (raf) cancelAnimationFrame(raf);
                if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
            }
        };
    }

    /* ---- disintegrate into sand --------------------------------------------
       The bar bursts into a field of tiny particles on a full-screen canvas.
       Cheap by construction: a dpr-1 backing store, the particle count capped
       (~800) no matter how wide the bar is, integer-aligned fillRects (no
       antialiasing), and the two grain colours drawn one fillStyle per pass.
       Grain is 80/20: mostly black with white sparkle in dark mode, inverse in
       light. Takes a pre-measured rect (no read-after-write layout). */
    function explode(rect) {
        if (!rect || rect.width < 2 || rect.height < 2) return;
        var lightMode = document.documentElement.classList.contains('lightMode');
        var majorCol = lightMode ? '#ffffff' : '#000000';   /* 80% */
        var minorCol = lightMode ? '#000000' : '#ffffff';   /* 20% */
        var vw = window.innerWidth, vh = window.innerHeight, killY = vh + 24;
        var canvas = document.createElement('canvas');
        canvas.className = 'lv2-promo-sand';
        canvas.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;z-index:100040;pointer-events:none;';
        /* dpr 1: tiny transient grains don't need a retina backing store, and it
           cuts the per-frame clear + raster by ~1.5x on retina displays. */
        canvas.width = vw; canvas.height = vh;
        var ctx = canvas.getContext('2d');
        document.body.appendChild(canvas);
        /* Cap the field to ~800 grains: a full-width bar at 6px spawned ~1900,
           which is what made the blast drop frames. Gap grows with bar area so
           the count stays bounded while narrow bars keep the fine 6px grain. */
        var gap = Math.max(SAND_GAP, Math.sqrt(rect.width * rect.height / 800));
        var major = [], minor = [];
        for (var gy = rect.top; gy < rect.bottom; gy += gap) {
            for (var gx = rect.left; gx < rect.right; gx += gap) {
                var nx = (gx - rect.left) / rect.width - 0.5;
                (Math.random() < 0.8 ? major : minor).push({
                    x: gx + Math.random() * gap,
                    y: gy + Math.random() * gap,
                    vx: nx * (7 + Math.random() * 9) + (Math.random() * 2 - 1) * 1.2,
                    vy: -(0.6 + Math.random() * 3.6),
                    sz: Math.random() < 0.5 ? 1 : 2
                });
            }
        }
        var g = 0.16, start = null, last = null;
        /* Clear only the region grains actually occupy each frame, not the whole
           viewport — the full-viewport clear was the real per-frame floor. */
        var dirty = { x0: rect.left, y0: rect.top, x1: rect.right, y1: rect.bottom };
        var bb = { x0: 0, y0: 0, x1: 0, y1: 0 };
        function step(arr, dt) {
            for (var i = 0; i < arr.length; i++) {
                var p = arr[i];
                if (p.dead) continue;
                p.vy += g * dt; p.x += p.vx * dt; p.y += p.vy * dt;
                if (p.y > killY) p.dead = true;
            }
        }
        function draw(arr) {
            for (var i = 0; i < arr.length; i++) {
                var p = arr[i];
                if (p.dead) continue;
                var x = p.x | 0, y = p.y | 0;
                ctx.fillRect(x, y, p.sz, p.sz);
                if (x < bb.x0) bb.x0 = x;
                if (y < bb.y0) bb.y0 = y;
                if (x + p.sz > bb.x1) bb.x1 = x + p.sz;
                if (y + p.sz > bb.y1) bb.y1 = y + p.sz;
            }
        }
        function frame(now) {
            if (start == null) { start = now; last = now; }
            var dt = Math.min(2.5, (now - last) / 16.667) || 1; last = now;
            var el = now - start;
            /* wipe last frame's footprint (padded), then re-measure this frame's */
            ctx.clearRect(dirty.x0 - 2, dirty.y0 - 2, (dirty.x1 - dirty.x0) + 4, (dirty.y1 - dirty.y0) + 4);
            step(major, dt); step(minor, dt);
            bb.x0 = 1e9; bb.y0 = 1e9; bb.x1 = -1e9; bb.y1 = -1e9;
            ctx.globalAlpha = el < SAND_MS * 0.5 ? 1 : Math.max(0, 1 - (el - SAND_MS * 0.5) / (SAND_MS * 0.5));
            ctx.fillStyle = majorCol; draw(major);
            ctx.fillStyle = minorCol; draw(minor);
            ctx.globalAlpha = 1;
            dirty = (bb.x1 < bb.x0) ? { x0: 0, y0: 0, x1: 0, y1: 0 } : bb;
            if (el < SAND_MS) requestAnimationFrame(frame);
            else if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        }
        requestAnimationFrame(frame);
    }

    function collapse(clickedBar) {
        if (crackCtl) { crackCtl.stop(); crackCtl = null; }
        /* measure the sand source box BEFORE mutating classes (no read-after-write) */
        var rect = clickedBar.getBoundingClientRect();
        bars().forEach(function (b) { b.classList.remove('lv2-promo-cutscene'); });
        explode(rect);
        bars().forEach(function (b) {
            b.classList.add('lv2-promo-host', 'lv2-promo-emptying');
            requestAnimationFrame(function () { b.classList.add('lv2-promo-gone'); });
        });
        busy = false;
    }

    function onClose(clickedBar, btn) {
        if (busy) return;
        busy = true;
        dismissed = true;
        if (reduce) {
            bars().forEach(function (b) { b.classList.add('lv2-promo-hidden'); });
            busy = false;
            return;
        }
        /* Measure BEFORE any style writes — no forced read-after-write. */
        var rect = clickedBar.getBoundingClientRect();
        /* Cold click (page still loading) -> lighter fracture, so the setup stays
           cheap while the homepage is still booting. */
        var light = document.readyState !== 'complete';
        /* Instant feedback: the X spin + marquee pause (cutscene class) paint
           FIRST; the heavier canvas setup is deferred two frames off the input
           task so it never blocks the click response. */
        btn.classList.add('lv2-promo-close--spinning');
        bars().forEach(function (b) { b.classList.add('lv2-promo-host', 'lv2-promo-cutscene'); });
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { crackCtl = crackle(rect, light); });
        });
        setTimeout(function () { collapse(clickedBar); }, SPIN_MS);
    }

    function addButton(bar) {
        if (bar.querySelector('.lv2-promo-close')) return;
        if (!hasContent(bar)) return;
        bar.classList.add('lv2-promo-host');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lv2-promo-close';
        b.setAttribute('aria-label', 'Close promotional banner');
        b.innerHTML = '<svg class="lv2-promo-x" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path d="M5 5 L19 19 M19 5 L5 19" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';
        b.addEventListener('click', function () { onClose(bar, b); });
        bar.appendChild(b);
    }

    function setup() {
        var found = bars().filter(hasContent);
        if (!found.length) return false;
        if (dismissed) {
            found.forEach(function (b) { b.classList.add('lv2-promo-hidden'); });
            return true;
        }
        found.forEach(addButton);
        return true;
    }

    /* The marquee is built by product_browser.js after its async boot, so poll
       briefly for it, then keep a light observer in case the grid re-renders it. */
    function init() {
        if (!setup()) {
            var started = Date.now();
            var iv = setInterval(function () {
                if (setup() || Date.now() - started > 15000) clearInterval(iv);
            }, 200);
        }
        if (typeof MutationObserver === 'function') {
            try {
                new MutationObserver(function () {
                    if (busy) return;
                    if (dismissed) {
                        bars().forEach(function (b) {
                            if (hasContent(b)) b.classList.add('lv2-promo-hidden');
                        });
                    } else {
                        bars().forEach(function (b) { if (hasContent(b)) addButton(b); });
                    }
                }).observe(document.body, { childList: true, subtree: true });
            } catch (e) { /* no-op */ }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
